import type { CatalogItemCategoryChangeInput } from './types';
import type { MappedCatalogItem } from 'entities/CatalogItem/model/types/CatalogItemSchema';

/**
 * Maps Redux `selectedItems` into rows the change-category flow can PATCH
 * (`id`, `title`, `categoryId`). Uses `title` / `propertyCategoryId` captured when the row
 * was checked (see `addMultiselectItem`).
 */
export const resolveSelectionToItemInput = (
    selectedItems: Record<string, Partial<MappedCatalogItem>> | undefined,
): CatalogItemCategoryChangeInput[] => {
    if (!selectedItems) {
        return [];
    }

    const rows: CatalogItemCategoryChangeInput[] = [];
    const seen = new Set<string>();

    for (const [mapKey, entry] of Object.entries(selectedItems)) {
        const rowId = entry.catalogItemId ?? mapKey;
        if (
            entry.title !== undefined &&
            entry.propertyCategoryId !== undefined &&
            !seen.has(rowId)
        ) {
            seen.add(rowId);
            rows.push({
                id: rowId,
                title: entry.title,
                categoryId: entry.propertyCategoryId,
            });
        }
    }

    return rows;
};
